import { containerTypeColumns } from '@Constants/TableColumns';
import { EnumFrontendLayoutSetting, type ApiContainerType, ApiImportExternalErpItemsRequest } from '@Model';
import { useStammdatenRepository } from '@Hooks/useRepository';
import { ExternalErpContainerTypesRepository } from '@Repositories/Stammdaten';
import { useCallback } from 'react';
import type { ListRequest } from '@synqo/frontend-component-library';
import { type ImportFlowControlProps, ImportExternalErpItemsFlow } from './ImportExternalErpItemsFlow';

// @ai-generated 2026-10-22T13:20:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function ImportExternalErpContainerTypesFlow({ isOpen, onClose, onImported }: ImportFlowControlProps) {
    const repository = useStammdatenRepository(ExternalErpContainerTypesRepository);

    const loadImportable = useCallback(
        (listRequest: ListRequest) => repository.getImportableContainerTypes(listRequest),
        [repository],
    );
    const importSelected = useCallback(
        (request: ApiImportExternalErpItemsRequest) => repository.importContainerTypes(request),
        [repository],
    );

    return (
        <ImportExternalErpItemsFlow<ApiContainerType>
            isOpen={isOpen}
            onClose={onClose}
            onImported={onImported}
            title="Containertypen aus ERP importieren"
            name="ErpContainerTypeList"
            itemsLabel="Containertypen"
            columns={containerTypeColumns}
            layoutSettingsContext={EnumFrontendLayoutSetting.ContainerTypesTableLayout}
            loadImportable={loadImportable}
            importSelected={importSelected}
        />
    );
}
